// extracted by mini-css-extract-plugin
export default {"cancelllation-content":"cancellation_cancelllation-content__4JRgj","data-heading":"cancellation_data-heading__nzv0q"};